<template>
  <el-drawer :title="formItem.id ? '修改技师信息' : '添加技师信息'" size="50%" :visible.sync="open_modal">
    <div class="acea-row head">
      <div style="display: flex; align-items: center; padding: 30px" v-if="formItem.id">
        <el-image
          style="width: 50px; height: 50px; border-radius: 50%"
          :src="formItem.thumb"
          :preview-src-list="[formItem.thumb]"
        >
        </el-image>
        <div style="margin-left: 10px">
          <p>{{ formItem.name }}</p>
          <p>{{ formItem.phone }}</p>
        </div>
      </div>
      <div class="edit-btn">
        <el-button class="ivu-btn ivu-btn-default common-form-button" @click="reset">取消</el-button>
        <el-button class="ivu-btn ivu-btn-primary common-form-button" @click="submit" type="primary" v-loading="loading"
          >保存</el-button
        >
      </div>
    </div>
    <el-form ref="formItem" style="padding: 30px" :model="formItem" label-width="120px" @submit.native.prevent>
      <el-row type="flex" justify="space-between">
        <el-col :span="24">
          <el-tabs class="mb20" v-model="activeName" @tab-click="changeType">
            <el-tab-pane :name="item.val" v-for="(item, index) in list" :key="index" :label="item.label"></el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
      <template v-if="activeName === 'base'">
        <div class="section">
          <div class="section-hd">技师信息</div>
          <div class="section-bd">
            <div class="item">
              <el-form-item label="技师姓名：" prop="name">
                <el-input class="form-sty" v-model.trim="formItem.name" placeholder="请输入技师姓名"></el-input>
              </el-form-item>
            </div>
            <div class="item">
              <el-form-item label="联系电话：" prop="phone">
                <el-input class="form-sty" v-model="formItem.phone" placeholder="请输入联系电话"></el-input>
              </el-form-item>
            </div>
            <!-- <div class="item">
              <el-form-item label="绑定用户:" prop="nickname">
                <div class="upLoadPicBox" @click="bindUser">
                  <div v-if="formItem.uid > 0" class="acea-row">
                    <img class="pictrue" :src="selectedUser.image" />
                    <div>{{ formItem.nickname }}</div>
                  </div>
                  <div v-else class="upLoad">
                    <i class="el-icon-camera cameraIconfont" />
                  </div>
                </div>
              </el-form-item>
            </div> -->
            <div class="item">
              <el-form-item label="出生日期：">
                <el-date-picker
                  class="form-sty"
                  type="date"
                  v-model="formItem.birthday"
                  placeholder="请选择出生年月日"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </div>
            <div class="item">
              <el-form-item label="所在城市：" prop="city_id">
                <el-select class="form-sty " v-model="formItem.cityId" filterable size="medium">
                  <el-option
                    v-for="(item, index) in cityList"
                    :value="item.id"
                    :key="index"
                    :label="item.cityName"
                  >{{ item.cityName }}</el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="item">
              <el-form-item label="技师性别：" prop="sex">
                <el-radio-group v-model="formItem.sex">
                  <el-radio-button :label="1">男</el-radio-button>
                  <el-radio-button :label="2">女</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="item">
              <el-form-item label="技师头像：" prop="image" >
                <el-tooltip content="建议尺寸：240*240px" placement="top">
                  <div class="upLoadPicBox" @click="modalPicTap(false, 'thumb')">
                    <div v-if="formItem.thumb" class="pictrue">
                      <img :src="formItem.thumb" />
                    </div>
                    <div v-else class="upLoad">
                      <i class="el-icon-camera cameraIconfont" />
                    </div>
                  </div>
                </el-tooltip>
              </el-form-item>
            </div>
            <div class="item">
              <el-form-item label="技师照片：" prop="slider_image">
                <div class="acea-row">
                  <div
                    v-for="(item, index) in formItem.imgsArray"
                    :key="index"
                    class="pictrue"
                    draggable="true"
                    @dragstart="handleDragStart($event, item)"
                    @dragover.prevent="handleDragOver($event, item)"
                    @dragenter="handleDragEnter($event, item)"
                    @dragend="handleDragEnd($event, item)"
                  >
                    <el-image 
                      :src="item" 
                      :preview-src-list="formItem.imgsArray"
                      fit="cover"
                      style="width: 100%; height: 100%"
                    />
                    <i class="el-icon-error btndel" @click="handleRemove(index)" />
                  </div>
                  <el-tooltip content="建议尺寸：375*260px" placement="top">
                    <div v-if="formItem.imgsArray.length < 4" class="upLoadPicBox" @click="modalPicTap(true, 'imgs')">
                      <div class="upLoad">
                        <i class="el-icon-camera cameraIconfont" />
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </el-form-item>
            </div>
            <div class="item">
              <el-form-item label="个人简介：" prop="resume">
                <el-input class="form-sty" v-model="formItem.resume" type="textarea" placeholder="请输入个人简介" />
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="section">
          <div class="section-hd">紧急联系人</div>
          <div class="section-bd">
            <div class="item">
              <el-form-item label="联系人姓名：" prop="emergency_contact">
                <el-input
                  class="form-sty"
                  v-model="formItem.emergencyContact"
                  placeholder="请输入紧急联系人"
                ></el-input>
              </el-form-item>
            </div>
            <div class="item">
              <el-form-item label="联系人电话：" prop="emergency_phone">
                <el-input
                  class="form-sty"
                  v-model="formItem.emergencyPhone"
                  placeholder="请输入紧急联系人电话"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="section">
          <div class="section-hd">账号密码</div>
          <div class="section-bd">
            <div class="item">
              <el-form-item label="登录帐号：" prop="login_name">
                <el-input class="form-sty" v-model="formItem.loginName" placeholder="请输入登录帐号"></el-input>
              </el-form-item>
            </div>
            <div class="item">
              <el-form-item label="登录密码：" prop="pwd">
                <el-input class="form-sty" v-model="formItem.pwd" placeholder="请输入登录密码"></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="section">
          <div class="section-hd">基本概况</div>
          <div class="section-bd">
            <div class="item">
              <el-form-item label="技师分类：" prop="staff_cate_id">
                <el-select class="form-sty" v-model="formItem.staffCateId" filterable>
                  <el-option
                    v-for="(item, index) in staffCateList"
                    :value="item.id"
                    :key="index"
                    :label="item.title"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="item">
              <el-form-item label="技师标签：" prop="service_label">
                <el-select v-model="formItem.serviceLabelArray" multiple filterable class="form-sty">
                  <el-option
                    v-for="(item, index) in service_label"
                    :value="item.name"
                    :key="index"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="item">
              <el-form-item label="排序：">
                <el-input-number class="form-sty" placeholder="请输入排序" :precision="0" v-model="formItem.sort" />
              </el-form-item>
            </div>
            <div class="item lang">
              <el-form-item label="是否推荐：">
                <el-radio-group v-model="formItem.isRecommend">
                  <el-radio-button :label="0">不推荐</el-radio-button>
                  <el-radio-button :label="1">推荐</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="item lang">
              <el-form-item label="是否启用：">
                <el-radio-group v-model="formItem.status">
                  <el-radio-button :label="0">禁用</el-radio-button>
                  <el-radio-button :label="1">启用</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="item lang">
              <el-form-item label="是否模拟：">
                <el-switch
                  v-model="formItem.isMock"
                  active-text="是"
                  inactive-text="否"
                  :active-value="1"
                  :inactive-value="0"
                />
              </el-form-item>
            </div>
            <div class="item lang">
              <el-form-item label="是否培训：">
                <el-switch
                  v-model="formItem.isTraining"
                  active-text="是"
                  inactive-text="否"
                  :active-value="1"
                  :inactive-value="0"
                />
              </el-form-item>
            </div>
          </div>
        </div>
      </template>
      <template v-if="activeName === 'work'">
        <!-- <div class="section">
          <div class="section-hd">工作时间</div>
          <div class="section-bd">
            <div class="item">
              <el-form-item label="上班日期：" prop="week_str">
                <el-checkbox-group v-model="formItem.weekStrArray" @change="onChangeWeekStr">
                  <el-checkbox :label="1">周一</el-checkbox>
                  <el-checkbox :label="2">周二</el-checkbox>
                  <el-checkbox :label="3">周三</el-checkbox>
                  <el-checkbox :label="4">周四</el-checkbox>
                  <el-checkbox :label="5">周五</el-checkbox>
                  <el-checkbox :label="6">周六</el-checkbox>
                  <el-checkbox :label="7">周日</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
            <div class="item">
              <el-form-item label="基础工作时间：">
                <el-time-picker
                  v-model="formItem.startTime"
                  format="HH:mm"
                  value-format="HH:mm"
                  style="width: 45%"
                  placeholder="选择开始时间"
                >
                </el-time-picker>
                <span style="margin: 0 4px">至</span>
                <el-time-picker
                  v-model="formItem.endTime"
                  format="HH:mm"
                  value-format="HH:mm"
                  style="width: 45%"
                  placeholder="选择结束时间"
                >
                </el-time-picker>
              </el-form-item>
            </div>
            <div class="item lang">
              <el-alert
                title="详细排班设置"
                type="info"
                description="基础工作时间仅作为参考，具体的接单时段请在技师列表中点击'排班'按钮进行详细设置，支持按30分钟时段精确管理。"
                show-icon
                :closable="false"
              />
            </div>
          </div>
        </div> -->
        <div class="section">
          <div class="section-hd">工作地点</div>
          <div class="section-bd">
            <div class="item" style="width: 100%">
              <el-form-item label="接单地址：" prop="latlng">
                <el-input
                  style="width: 100%"
                  v-model="formItem.place"
                  enter-button="查找位置"
                  placeholder="请查找位置"
                  readonly
                >
                  <el-button
                    slot="append"
                    style="background: #46a6ff; color: #fff; border-radius: 0 4px 4px 0"
                    @click="openMapModal"
                    >请点击查找位置</el-button
                  >
                </el-input>
              </el-form-item>
            </div>
            <div class="item">
              <el-form-item label="接单范围(km)：" prop="service_radius">
                <el-input-number
                  class="form-sty"
                  placeholder="请输入接单范围"
                  :precision="0"
                  :min="0"
                  v-model="formItem.serviceRadius"
                />
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="section">
          <div class="section-hd">工作设置</div>
          <div class="section-bd">
            <div class="item">
              <el-form-item label="是否上班：">
                <el-radio-group v-model="formItem.workStatus">
                  <el-radio-button :label="0">下班</el-radio-button>
                  <el-radio-button :label="1">上班</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="item">
              <el-form-item label="接单模式：">
                <el-select v-model="formItem.orderMode" placeholder="请选择接单模式" style="width: 300px">
                  <el-option label="自动接单" value="auto"></el-option>
                  <el-option label="手动接单" value="manual"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="item">
              <el-form-item label="最大接单数：">
                <el-input-number
                  v-model="formItem.maxOrders"
                  :min="1"
                  :max="50"
                  placeholder="请输入最大接单数"
                  style="width: 300px"
                />
              </el-form-item>
            </div>
          </div>
        </div>
      </template>
      <template v-if="activeName === 'attestation'">
        <div class="section">
          <div class="section-hd">认证信息</div>
          <div class="section-bd">
            <div class="item lang">
              <el-form-item label="身份证号：">
                <el-input class="form-sty" v-model.trim="formItem.idcardNo" placeholder="请输入身份证号"></el-input>
              </el-form-item>
            </div>
            <div class="item">
              <el-form-item label="身份证正面：">
                <div class="picBox" @click="modalPicTap(false, 'idcard_a')">
                  <div v-if="formItem.idcardA" class="pictrue">
                    <img :src="formItem.idcardA" />
                  </div>
                  <div v-else class="upLoad acea-row row-center-wrapper">
                    <i class="el-icon-camera cameraIconfont" />
                  </div>
                </div>
              </el-form-item>
            </div>
            <div class="item">
              <el-form-item label="身份证反面：">
                <div class="picBox" @click="modalPicTap(false, 'idcard_b')">
                  <div class="pictrue" v-if="formItem.idcardB">
                    <img :src="formItem.idcardB" />
                  </div>
                  <div class="upLoad acea-row row-center-wrapper" v-else>
                    <i class="el-icon-camera cameraIconfont" />
                  </div>
                </div>
              </el-form-item>
            </div>
            <div class="item">
              <el-form-item label="健康证：">
                <div class="picBox" @click="modalPicTap(false, 'health_pic')">
                  <div class="pictrue" v-if="formItem.healthPic">
                    <img :src="formItem.healthPic" />
                  </div>
                  <div class="upLoad acea-row row-center-wrapper" v-else>
                    <i class="el-icon-camera cameraIconfont" />
                  </div>
                </div>
              </el-form-item>
            </div>
            <div class="item">
              <el-form-item label="职业技能等级证书：">
                <div class="picBox" @click="modalPicTap(false, 'qualification')">
                  <div class="pictrue" v-if="formItem.qualification">
                    <img :src="formItem.qualification" />
                  </div>
                  <div class="upLoad acea-row row-center-wrapper" v-else>
                    <i class="el-icon-camera cameraIconfont" />
                  </div>
                </div>
              </el-form-item>
            </div>
            <div class="item">
              <el-form-item label="职业道德考核证书：">
                <div class="picBox" @click="modalPicTap(false, 'qualification_b')">
                  <div class="pictrue" v-if="formItem.qualificationB">
                    <img :src="formItem.qualificationB" />
                  </div>
                  <div class="upLoad acea-row row-center-wrapper" v-else>
                    <i class="el-icon-camera cameraIconfont" />
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>
        </div>
      </template>
    </el-form>
    <el-dialog :visible.sync="modalMap" :modal="false" title="请选择地址" class="mapBox" append-to-body>
      <iframe id="mapPage" width="100%" height="500px" frameborder="0" :src="keyUrl" />
    </el-dialog>
    <!--用户列表-->
    <el-dialog class="big-dialog" title="用户列表" :visible.sync="userVisible" width="900px" append-to-body>
      <user-list v-if="userVisible" @getTemplateRow="getTemplateRow"></user-list>
      <!-- <span slot="footer">
        <el-button @click="userVisible = false">取 消</el-button>
        <el-button type="primary" @click="userVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>
  </el-drawer>
</template>

<script>
import { siteConfigApi, createServiceStaff, getServiceStaffInfo, getStaffCateOption, getServiceLabel, getSystemTagConfig, getCityOptions } from '@/api/technician';
import request from '@/utils/request';
import userList from '@/components/userList/index.vue';

export default {
  name: 'editForm',
  components: { userList },
  data() {
    return {
      isChoice: '单选',
      open_modal: false,
      modalPic: false,
      customerShow: false,
      modalMap: false,
      activeName: 'base',
      grid: {
        xl: 8,
        lg: 8,
        md: 12,
        sm: 24,
        xs: 24,
      },
      gridPic: {
        xl: 6,
        lg: 8,
        md: 12,
        sm: 12,
        xs: 12,
      },
      gridBtn: {
        xl: 4,
        lg: 8,
        md: 8,
        sm: 8,
        xs: 8,
      },
      keyUrl: '',
      formItem: {
        id: 0,
        uid: 0,
        name: '',
        loginName: '',
        pwd: '',
        phone: '',
        sex: 1,
        sort: 0,
        birthday: '',
        workTime: '',
        resume: '',
        weekStrArray: [],
        startTime: '',
        endTime: '',
        thumb: '',
        imgsArray: [],
        place: '',
        latitude: '',
        longitude: '',
        serviceRadius: 0,
        isRecommend: 0,
        status: 0,
        staffCateId: '',
        emergencyPhone: '',
        emergencyContact: '',
        serviceLabelArray: [],
        cityId: '',
        workStatus: 0,
        nickname: '',
        orderMode: 'manual', // 接单模式
        maxOrders: 5, // 最大接单数
        idcardNo: '', // 初始化身份证号
        idcardA: '',
        idcardB: '',
        healthPic: '',
        qualification: '',
        qualificationB: '',
        isMock: 0, // 是否模拟
        isTraining: 0 // 是否培训
      },
      images: [],
      companyList: [],
      loading: false,
      staffCateList: [],
      service_label: [],
      cityList: [],
      list: [
        { val: 'base', label: '基本信息' },
        { val: 'work', label: '工作信息' },
        { val: 'attestation', label: '认证信息' },
      ],
      timeVal: '',
      selectedUser: {
        image: '',
        nickname: '',
      },
      userVisible: false,
    };
  },
  mounted() {
    // 初始化数据
    this.getCityOption();
    this.getStaffCateOption();
    this.getServiceLabel();
    
    window.addEventListener(
      'message',
      function (event) {
        // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
        var loc = event.data;
        if (loc && loc.module === 'locationPicker') {
          // 防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
          window.parent.selectAdderss(loc);
        }
      },
      false,
    );
    window.selectAdderss = this.selectAdderss;
  },
  methods: {
    bindUser() {
      this.userVisible = true;
    },
    getTemplateRow(row) {
      this.formItem.uid = row.id;
      this.formItem.nickname = row.nickname;
      this.selectedUser = {
        image: row.avatar,
        nickname: row.nickname,
      };
      this.userVisible = false;
    },
    // tab选项
    changeType(tab, event) {
      //this.activeName = tab;
    },
    // 选择工作日期
    onChangeWeekStr(evt) {
      this.formItem.weekStrArray = evt;
    },
    // 获取城市
    getCityOption() {
      getCityOptions().then((data) => {
        console.log("获取城市数据", data);
        this.cityList = data.data || [];
        console.log("处理后的城市列表", this.cityList);
      }).catch(err => {
        console.error('获取城市列表失败:', err);
      });
    },
    // 获取服务标签
    getServiceLabel() {
      // 优先使用系统配置的标签数据
      getSystemTagConfig().then((data) => {
        const parsedData = JSON.parse(data.value || '[]');
        let tagList = [];
        
        if (Array.isArray(parsedData)) {
          tagList = parsedData;
        } else if (parsedData.tagList && Array.isArray(parsedData.tagList)) {
          tagList = parsedData.tagList;
        }
        
        // 转换为标签选择器需要的格式
        this.service_label = tagList.map(tag => {
          if (typeof tag === 'string') {
            return { name: tag };
          } else {
            return { name: tag.name || '' };
          }
        });
        
        console.log('使用系统配置标签:', this.service_label);
      }).catch((err) => {
        console.error('获取系统标签配置失败，使用原有方法:', err);
        // 如果获取系统配置失败，回退到原来的方法
        getServiceLabel().then((data) => {
          this.service_label = data;
          console.log('使用原有标签数据:', this.service_label);
        });
      });
    },
    // 技师分类
    getStaffCateOption() {
      getStaffCateOption()
        .then((data) => {
          this.staffCateList = data;
        })
        .catch((err) => {
          this.$message.error(err.msg);
        });
    },
    // 获取详情
    getInfo(id) {
      getServiceStaffInfo({ id: id })
        .then((res) => {
          console.log("获取详情数据", res);
          if (!res.data) {
            this.$message.error('信息不存在');
            return false;
          }
          let data = res.data
          this.formItem.id = data.id;
          this.formItem.uid = data.uid;
          this.formItem.nickname = data.nickname;
          this.selectedUser.image = data.avatar;
          this.selectedUser.nickname = data.nickname;
          this.formItem.name = data.name;
          this.formItem.phone = data.phone;
          this.formItem.sex = data.sex;
          this.formItem.sort = data.sort;
          this.formItem.birthday = data.birthday;
          this.formItem.workTime = data.workTime;
          this.formItem.resume = data.resume;
          this.formItem.weekStrArray = data.weekStrArray || [];
          this.formItem.startTime = data.startTime;
          this.formItem.endTime = data.endTime;
          this.formItem.thumb = data.thumb;
          this.formItem.imgsArray = data.imgsArray || [];
          this.formItem.place = data.place;
          this.formItem.latitude = data.latitude;
          this.formItem.longitude = data.longitude;
          this.formItem.serviceRadius = parseFloat(data.serviceRadius);
          this.formItem.isRecommend = data.isRecommend;
          this.formItem.status = data.status;
          this.formItem.staffCateId = data.staffCateId;
          this.formItem.emergencyContact = data.emergencyContact;
          this.formItem.emergencyPhone = data.emergencyPhone;
          this.formItem.serviceLabelArray = data.serviceLabelArray || [];
          this.formItem.cityId = data.cityId;
          this.formItem.loginName = data.loginName;
          this.formItem.workStatus = data.workStatus;
          // this.formItem.nickname = data.nickname; // 已在前面赋值
          this.formItem.idcardNo = data.idcardNo;
          this.formItem.idcardA = data.idcardA;
          this.formItem.idcardB = data.idcardB;
          this.formItem.qualification = data.qualification;
          this.formItem.qualificationB = data.qualificationB;
          this.formItem.healthPic = data.healthPic;
          // isMock 和 isTraining 将通过 setMockAndTrainingValues 方法从列表数据中设置
        })
        .catch((err) => {
          this.$message.error(err.msg);
        });
    },
    // 设置模拟和培训值（从列表数据中获取）
    setMockAndTrainingValues(isMock, isTraining) {
      this.formItem.isMock = isMock ? 1 : 0;
      this.formItem.isTraining = isTraining ? 1 : 0;
    },
    // 打开地图弹窗
    openMapModal() {
      if (!this.keyUrl) {
        siteConfigApi()
          .then(async (res) => {
            // 处理API响应数据结构
            let keys = (res.data && res.data.tx_map_key) || res.tx_map_key;
            if (keys) {
              this.keyUrl = `https://apis.map.qq.com/tools/locpicker?type=1&key=${keys}&referer=myapp`;
              this.modalMap = true;
            } else {
              this.$message.error('未获取到地图密钥配置');
            }
          })
          .catch((res) => {
            this.$message.error(res.msg || '获取地图配置失败');
          });
      } else {
        this.modalMap = true;
      }
    },
    // 地图弹窗回调
    selectAdderss(data) {
      this.formItem.place = data.poiname;
      this.formItem.latitude = data.latlng.lat;
      this.formItem.longitude = data.latlng.lng;
      this.modalMap = false;
    },
    // 移动技师照片
    handleDragStart(e, item) {
      this.dragging = item;
    },
    // 移动技师照片
    handleDragEnd(e, item) {
      this.dragging = null;
    },
    // 移动技师照片
    handleDragOver(e) {
      e.dataTransfer.dropEffect = 'move';
    },
    // 移动技师照片
    handleDragEnter(e, item) {
      e.dataTransfer.effectAllowed = 'move';
      if (item === this.dragging) {
        return;
      }
      const newItems = [...this.formItem.imgsArray];
      const src = newItems.indexOf(this.dragging);
      const dst = newItems.indexOf(item);
      newItems.splice(dst, 0, ...newItems.splice(src, 1));
      this.formItem.imgsArray = newItems;
    },
    // 删除技师照片
    handleRemove(i) {
      this.formItem.imgsArray.splice(i, 1);
    },
    // 选择图片
    modalPicTap(multiple, type) {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.multiple = multiple;
      
      input.onchange = (event) => {
        const files = event.target.files;
        if (!files || files.length === 0) return;
        
        // 如果是多选但只允许单个文件的类型，只取第一个文件
        const filesToUpload = multiple ? Array.from(files) : [files[0]];
        
        // 上传文件
        this.uploadFiles(filesToUpload, type);
      };
      
      input.click();
    },
    
    // 上传文件到服务器
    async uploadFiles(files, type) {
      try {
        const uploadPromises = files.map(file => this.uploadSingleFile(file, type));
        const results = await Promise.all(uploadPromises);
        
        // 处理上传结果
        this.handleUploadResults(results, type);
      } catch (error) {
        console.error('文件上传失败:', error);
        this.$message.error('文件上传失败');
      }
    },
    
    // 上传单个文件
    uploadSingleFile(file, type) {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('multipart', file);
        
        // 根据不同类型设置不同的参数
        let model = 'user';
        let pid = '0';
        
        switch (type) {
          case 'thumb':
            model = 'user';
            pid = '7'; // 前台用户
            break;
          case 'imgs':
            model = 'product';
            pid = '1'; // 商品图片
            break;
          case 'idcard_a':
          case 'idcard_b':
          case 'health_pic':
          case 'qualification':
          case 'qualification_b':
            model = 'system';
            pid = '0'; // 编辑器
            break;
          default:
            model = 'user';
            pid = '0';
        }
        
        formData.append('model', model);
        formData.append('pid', pid);
        
        // 使用request发送请求
        request({
          url: '/admin/merchant/upload/file',
          method: 'post',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(response => {
          if (response.code === 200) {
            resolve(response.data);
          } else {
            reject(new Error(response.message || '上传失败'));
          }
        }).catch(error => {
          reject(error);
        });
      });
    },
    
    // 处理上传结果
    handleUploadResults(results, type) {
      if (type === 'thumb') {
        this.formItem.thumb = results[0].url;
      } else if (type === 'qualification_b') {
        this.formItem.qualificationB = results[0].url;
      } else if (type === 'qualification') {
        this.formItem.qualification = results[0].url;
      } else if (type === 'health_pic') {
        this.formItem.healthPic = results[0].url;
      } else if (type === 'idcard_b') {
        this.formItem.idcardB = results[0].url;
      } else if (type === 'idcard_a') {
        this.formItem.idcardA = results[0].url;
      } else if (type === 'imgs') {
        results.forEach(result => {
          this.formItem.imgsArray.push(result.url);
        });
      }
      
      this.$message.success('图片上传成功');
    },
    // 重置
    reset() {
      this.formItem = {
        id: 0,
        uid: 0,
        name: '',
        loginName: '',
        pwd: '',
        phone: '',
        sex: 1,
        sort: 0,
        birthday: '',
        workTime: '',
        resume: '',
        weekStrArray: [],
        startTime: '',
        endTime: '',
        thumb: '',
        imgsArray: [],
        place: '',
        latitude: '',
        longitude: '',
        serviceRadius: 0,
        isRecommend: 0,
        status: 0,
        staffCateId: '',
        emergencyPhone: '',
        emergencyContact: '',
        serviceLabelArray: [],
        cityId: '',
        workStatus: 0,
        nickname: '',
        orderMode: 'manual', // 接单模式
        maxOrders: 5, // 最大接单数
        idcardNo: '', // 重置时也包含身份证号
        idcardA: '',
        idcardB: '',
        healthPic: '',
        qualification: '',
        qualificationB: '',
        isMock: 0, // 是否模拟
        isTraining: 0 // 是否培训
      };
      this.open_modal = false;
    },
    // 提交
    submit() {
      if (this.loading) return this.$message.info('请勿重复提交');
      if (!this.formItem.name) return this.$message.info('请输入技师姓名');
      if (!this.formItem.phone) return this.$message.info('请输入技师电话');
      this.loading = true;
      createServiceStaff(this.formItem)
        .then((res) => {
          this.loading = false;
          this.$message.success('保存成功');
          this.reset();
          this.$emit('submitOk');
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.msg);
        });
    },
    // 具体日期
    onchangeTime(e) {
      this.timeVal = e;
      this.formItem.birthday = this.timeVal.join('-');
    },
  },
};
</script>
<style scoped>

::v-deep .el-select .el-input{
  width:200px !important; 
}
.section {
  padding: 25px 0;
  border-bottom: 1px dashed #eeeeee;
}

.section-hd {
  padding-left: 10px;
  border-left: 3px solid #1890ff;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #303133;
}

.section-bd {
  display: flex;
  flex-wrap: wrap;
}

.section .item {
  width: 50%;
  display: flex;
  margin: 16px 0px 0 0;
  font-size: 13px;
  color: #606266;
}

.section .item:nth-child(3n + 3) {
  margin: 16px 0 0;
}

.section .item.lang {
  width: 100%;
}

.section .item .ivu-form-item {
  margin: 3px 0;
}

.section .item .addfont {
  display: inline-block;
  font-size: 13px;
  font-weight: 400;
  color: #1890ff;
  cursor: pointer;
  margin-left: 10px;
}

.section .item.lang {
  width: 100%;
}

.section .value {
  flex: 1;
}

.section .avatar {
  width: 60px;
  height: 60px;
  overflow: hidden;
}

.section .avatar img {
  width: 100%;
  height: 100%;
}

.head {
  position: relative;
}

.head .edit-btn {
  position: absolute;
  right: 10px;
  top: 0px;
  display: flex;
  align-items: center;
}
</style>
<style>


.labelInput {
  border: 1px solid #dcdee2;
  width: 400px;
  padding: 0 8px;
  border-radius: 5px;
  min-height: 30px;
  cursor: pointer;
}

.labelInput .span {
  color: #c5c8ce;
}

.labelInput .iconxiayi {
  font-size: 12px;
}

.addfont {
  display: inline-block;
  font-size: 13px;
  font-weight: 400;
  color: #1890FF;
  cursor: pointer;
  margin-left: 10px;
}

.ivu-icon-ios-arrow-down {
  font-size: 14px;
}

.item-s {
  margin-top: 20px;
}

.tip {
  color: #bbb;
}

.picBox {
  display: inline-block;
  cursor: pointer;
}

.picBox .upLoad {
  width: 58px;
  height: 58px;
  line-height: 58px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.02);
}

.picBox .pictrue {
  width: 60px;
  height: 60px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  margin-right: 10px;
}

.picBox .pictrue img {
  width: 100%;
  height: 100%;
}

.picBox .iconfont {
  color: #898989;
}

.pictrue {
  width: 60px;
  height: 60px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  margin-right: 10px;
}

.pictrue img {
  width: 100%;
  height: 100%;
}

.footer {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: end;
}

.footer .btn-save {
  margin-left: 10px;
}

.pictrue {
  width: 60px;
  height: 60px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  margin-right: 15px;
  display: inline-block;
  position: relative;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
  }

  .btndel {
    position: absolute;
    z-index: 1;
    width: 20px !important;
    height: 20px !important;
    left: 46px;
    top: -4px;
  }
}

.upLoad {
  width: 58px;
  height: 58px;
  line-height: 58px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.02);
  cursor: pointer;
}
.form-sty .el-form-item__content{
 width: 90% !important;
}
.el-select .el-input{
  width: 100% !important;
}
</style>
